import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logoText from '../../assets/images/power-fix-soloutions-text.png';
import { ICONS } from '../../constants';
import LanguageSwitcher from './LanguageSwitcher';

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  const navRef = useRef(null);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target) && isMenuOpen) {
        setIsMenuOpen(false);
        setIsServicesOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleServices = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsServicesOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <nav className="navigation" ref={navRef}>
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <span className="logo-icon">{ICONS.LIGHTNING}</span>
          <img src={logoText} alt="Power&Fix-Solutions" className="logo-text-image" />
        </Link>
        <div className="nav-divider"></div>

        <button
          className={`nav-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link
              to="/"
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              {t('nav.home')}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/about"
              className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              {t('nav.about')}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/pricing"
              className={`nav-link ${location.pathname === '/pricing' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              {t('nav.pricing')}
            </Link>
          </li>
          <li className={`nav-item nav-item-dropdown ${isServicesOpen ? 'open' : ''}`}>
            <button
              className={`nav-link dropdown-toggle ${['/groepenkast', '/renovatie', '/stroomstoringen', '/kookgroep', '/binnenverlichting'].includes(location.pathname) ? 'active' : ''}`}
              onClick={toggleServices}
            >
              {t('nav.services')}
              <span className="dropdown-arrow">▾</span>
            </button>
            <ul className="dropdown-menu">
              <li>
                <Link
                  to="/groepenkast"
                  className={location.pathname === '/groepenkast' ? 'active' : ''}
                  onClick={closeMenu}
                >
                  {t('nav.groepenkast')}
                </Link>
              </li>
              <li>
                <Link
                  to="/renovatie"
                  className={location.pathname === '/renovatie' ? 'active' : ''}
                  onClick={closeMenu}
                >
                  {t('nav.renovatie')}
                </Link>
              </li>
              <li>
                <Link
                  to="/kookgroep"
                  className={location.pathname === '/kookgroep' ? 'active' : ''}
                  onClick={closeMenu}
                >
                  {t('nav.kookgroep')}
                </Link>
              </li>
              <li>
                <Link
                  to="/stroomstoringen"
                  className={location.pathname === '/stroomstoringen' ? 'active' : ''}
                  onClick={closeMenu}
                >
                  {t('nav.stroomstoringen')}
                </Link>
              </li>
              <li>
                <Link
                  to="/binnenverlichting"
                  className={location.pathname === '/binnenverlichting' ? 'active' : ''}
                  onClick={closeMenu}
                >
                  {t('nav.binnenverlichting')}
                </Link>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <Link
              to="/contact"
              className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              {t('nav.contact')}
            </Link>
          </li>
          <li className="nav-item nav-item-language-mobile">
            <div className="language-switcher-mobile">
              <LanguageSwitcher />
            </div>
          </li>
          <li className="nav-item nav-item-right">
            <div className="language-switcher-desktop">
              <LanguageSwitcher />
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
